import { render, staticRenderFns } from "./MyChat.vue?vue&type=template&id=004512cf&scoped=true"
import script from "./MyChat.vue?vue&type=script&lang=js"
export * from "./MyChat.vue?vue&type=script&lang=js"
import style0 from "./MyChat.vue?vue&type=style&index=0&id=004512cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004512cf",
  null
  
)

export default component.exports